// src/components/common/LoadingSpinner.tsx
import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner: React.FC = () => (
    <div className="spinner-overlay">
      <div className="spinner" />
    </div>
);

export default LoadingSpinner;
